export default "__VITE_ASSET__XOQFnZeU__"